import { apiSlice } from "app/api/apiSlice"

export const safetyApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['safetyAlarms'],
    endpoints: builder => ({
        // ALL EVENTS
        getSafetyAlarms: builder.query({
            query: () => {
                return {
                    url: 'safety/alarms',
                    method: 'GET'
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['safetyAlarms']
        }),
        getSafetyStats: builder.query({
            query: (durationDays) => {
                const params = new URLSearchParams();
                if (durationDays && durationDays > 0) params.append("durationDays", durationDays);
                return {
                    url: `safety/alarms/stats?${params.toString()}`,
                    method: 'GET'
                };
            },
            keepUnusedDataFor: 5
        }),
        PutSafetyAlarmProgress: builder.mutation({
            query: ({ guid, status }) => {
                return {
                    url: 'safety/alarm',
                    method: 'PUT',
                    params: {
                        guid: guid,
                        status: status
                    }
                }
            }
        }),
        launchAlarm: builder.mutation({
            query: () => {
                return {
                    url: 'safety/alarm',
                    method: 'POST',
                     body: {
                        type : "SOS",
                        triggeredAt: new Date().getTime() / 1000
                     }
                }
            }
        })
    })
})

export const {
    useGetSafetyAlarmsQuery,
    useGetSafetyStatsQuery,
    usePutSafetyAlarmProgressMutation,
    useLaunchAlarmMutation
} = safetyApiSlice
